import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Accordion from '@enlighten/design-system/dist/Accordion';
import AccordionDetails from '@enlighten/design-system/dist/AccordionDetails';
import AccordionSummary from '@enlighten/design-system/dist/AccordionSummary';
import Box from '@enlighten/design-system/dist/Box';
import Grid from '@enlighten/design-system/dist/Grid';
import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Fragment } from 'react';
const list = [
    {
        title: '해당 보험 상품 가입 시 엔라이튼 RTU 상품을 가입해야 하나요?',
        content: '해당 상품은 엔라이튼의 RTU를 가입하지 않으셔도, 가입이 가능합니다.',
    },
    {
        title: 'ESS 보험 가입도 가능한가요?',
        content: `네, ESS 정책성 보험 상품이 출시되었습니다. 보장성이 높아 발전소 인수 시에 유리하고, 시중 보험 대비 저렴하다는 장점이 있습니다.
태양광발전소종합보험 전담센터(TPA코리아)와 상담 후 결정하시는 것을 추천드립니다. (문의처: 태양광발전소종합보험 전담센터 TPA코리아 1644-9664)`,
    },
    {
        title: '기업 휴업 손해에 대한 내용은 필수 가입인가요?',
        content: '기업 휴업 손해에 대한 부분은 선택 가입 사항이며, 필요 시 추가 가입 부탁 드립니다.',
    },
    {
        title: '배상책임 꼭 가입해야 하나요?',
        content: `한화손보 ✕ TPA코리아는 재물손해와 배상 책임을 필수로 가입하셔야 합니다. 기업휴지보험만 선택사항입니다.
배상책임보험은 제3자에게 발생한 피해를 보장하는 중요한 요소입니다.`,
    },
    {
        title: '입금 전에 가입증명서를 받을 수 있나요?',
        content: '가입증명서는 보험청약 확정에 대한 서류로 입금 후에 발행됩니다. 입금 이전에는 가입 상담 및 가입안내문만 확인 가능합니다.',
    },
    {
        title: '가입증명서는 어떤 방식으로 받아볼 수 있나요?',
        content: '가입증명서 및 약관은 이메일로 송부드리며, 해당 파일이 원본입니다. 단, 질권은행으로는 가입증명서 원본 1 부씩 우편으로 발송됩니다.',
    },
    {
        title: 'TPA KOREA는 어떤 회사인가요?',
        content: `TPA KOREA는 기업의 보험 비용 절감과 효율적 리스크 관리를 목표로 설립된 기업 보험 전문 대리점 입니다.
당사는 기업보험 전문가들로 구성되어 보험관련 전문 서비스(위험관리 컨설팅, 사고대응, 고객응대 전담팀을 구성)를 제공하고 있으며,
각 산업에 최적화된 맞춤형 솔루션으로 국가기관, 지방자치단체, 일반기업 등으로 부터 신뢰받는 보험 파트너로 자리매김하였습니다.`,
    },
    {
        title: '올비즈커넥트는 어떤 회사인가요?',
        content: `올비즈커넥트는 전국의 태양광발전소를 운영하시는 고객님을 구성원으로 하여 결속하기 위한 별도의 법인입니다.
따라서, 본 태양광종합보험이 단체 계약 구조를 구성할 수 있으며, 개별가입 대비 평균 15~30% 수준의 보험료 할인 효과가 혜택을 제공해드리고 있습니다.`,
    },
];
export default function Section7() {
    return (_jsx(Stack, { justifyContent: "center", alignItems: "center", padding: { xs: '60px 24px', md: '100px 24px 140px' }, children: _jsxs(Stack, { alignItems: { xs: 'center', md: 'flex-start' }, gap: { xs: 3, md: '90px' }, width: "100%", maxWidth: 1392, children: [_jsx(Typography, { fontSize: { xs: 24, md: 40 }, fontWeight: 700, textAlign: { xs: 'center', md: 'left' }, children: "\uC790\uC8FC \uBB3B\uB294 \uC9C8\uBB38" }), _jsx(Stack, { gap: { xs: '10px', md: '20px' }, width: "100%", children: list.map(({ title, content }, i) => (_jsxs(Fragment, { children: [_jsx(Box, { display: { xs: 'block', md: 'none' }, width: "100%", children: _jsxs(Grid, { border: "1px solid", borderColor: "grey.300", borderRadius: "10px", padding: "20px", boxShadow: "0 4px 10px #0000000D", children: [_jsx(Typography, { fontSize: 16, fontWeight: 700, children: title }), typeof content === 'string' ? (_jsx(Typography, { fontSize: 14, lineHeight: 1.5, marginTop: "10px", children: content })) : (content)] }, i) }), _jsx(Box, { display: { xs: 'none', md: 'block' }, width: "100%", children: _jsxs(Accordion, { sx: {
                                        bgcolor: 'grey.200',
                                        border: '2px solid',
                                        borderColor: 'grey.300',
                                        borderRadius: '20px',
                                        padding: '50px 40px',
                                        boxShadow: 'none',
                                        transition: 'box-shadow 0.3s ease',
                                        ':first-of-type, :last-of-type': {
                                            borderRadius: '20px',
                                        },
                                        '::before': {
                                            display: 'none',
                                        },
                                        '&.Mui-expanded': {
                                            bgcolor: '#F9FAFF',
                                            border: '2px solid #E3D3FB',
                                            margin: 0,
                                            boxShadow: '0 4px 4px #00000040',
                                        },
                                    }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMore, { fontSize: "large" }), sx: {
                                                padding: 0,
                                                '&.Mui-expanded': {
                                                    minHeight: 47,
                                                    margin: 0,
                                                },
                                                '.MuiAccordionSummary-content': {
                                                    fontSize: 28,
                                                    fontWeight: 700,
                                                    height: '100%',
                                                    margin: 0,
                                                    '&.Mui-expanded': {
                                                        margin: 0,
                                                    },
                                                },
                                            }, children: title }), _jsx(AccordionDetails, { sx: {
                                                fontSize: 20,
                                                lineHeight: 1.5,
                                                whiteSpace: 'pre-line',
                                                padding: '30px 0 0 0',
                                            }, children: content })] }, i) })] }, i))) })] }) }));
}
